import React from 'react'
import { RouteChildrenProps, useParams } from 'react-router-dom'
import { generatePath } from 'react-router-dom'
import { flowRight as compose } from 'lodash'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useTranslation } from 'react-i18next'

import {
  StaffEditForm,
  initialForm,
  schemaForm,
  renderBreadcrumbsEdit,
} from 'features/Staff'
import { Button } from 'components'
import { withBackOfficeCms } from 'helpers/hocs'
import { routes } from 'helpers/routes'
import { useBreadcrumbs } from 'helpers/hooks'

const StaffEdit = ({
  history,
}: RouteChildrenProps<{ id: string; productId: string }>): JSX.Element => {
  const { id } = useParams<{ id: string }>()
  const { t } = useTranslation(['common', 'layout'])

  const base = 'con-staff-form'

  const methods = useForm({
    defaultValues: initialForm,
    resolver: yupResolver(schemaForm),
  })

  /** TDDO: connect BFF later */
  const onSubmit = async () => {}

  useBreadcrumbs(renderBreadcrumbsEdit(id))

  return (
    <FormProvider {...methods}>
      <form className={base} onSubmit={methods.handleSubmit(onSubmit)}>
        <StaffEditForm />
        <div className={`${base}__submit-layout`}>
          <Button
            variants='ternary'
            onClick={() =>
              history.push(generatePath(routes.staff.path, { id }))
            }
          >
            {t('common:cancel.button')}
          </Button>
          <Button type='submit'>{t('common:save.button')}</Button>
        </div>
      </form>
    </FormProvider>
  )
}

export default compose(withBackOfficeCms)(StaffEdit)
